import { Routes } from '@common/constants';

const SEARCH_FLOW_CATEGORIES = new Set<string>([
  'rooms',
  'rates',
  'spa-stays',
  'spa-days',
  'spa-treatments',
  'spa-classes',
  'facilities',
  'tables',
]);

const SINGLE_DATE_CATEGORIES = new Set<string>([
  'spa-days',
  'spa-treatments',
  'spa-classes',
  'facilities',
  'tables',
]);

const CHILDREN_VISIBLE_CATEGORIES = new Set<string>(['rooms', 'rates', 'spa-stays']);

const SPA_CATEGORIES = new Set<string>([
  'spa-days',
  'spa-treatments',
  'spa-classes',
  'facilities',
]);

const CATEGORY_LIST_ROUTE: Record<string, string> = {
  rooms: Routes.ROOM_LIST,
  rates: Routes.RATE_LIST,
  'spa-stays': Routes.SPA_STAYS_LIST,
  'spa-days': Routes.SPA_DAY_LIST,
  'spa-treatments': Routes.SPA_TREATMENT_LIST,
  'spa-classes': Routes.SPA_CLASSES_LIST,
  facilities: Routes.FACILITY_LIST,
  tables: Routes.TABLES_HOME,
  products: Routes.PRODUCT_LIST,
  collections: Routes.CATEGORY_LIST,
};

export function entersSearchFlow(category: string): boolean {
  return SEARCH_FLOW_CATEGORIES.has(category);
}

export function isSingleDateCategory(category: string): boolean {
  return SINGLE_DATE_CATEGORIES.has(category);
}

export function showsChildrenCounter(category: string): boolean {
  return CHILDREN_VISIBLE_CATEGORIES.has(category);
}

export function getCategoryListRoute(category: string): string | undefined {
  return CATEGORY_LIST_ROUTE[category];
}

export type SearchHandoffQuery = Partial<{
  fromDate: string;
  toDate: string;
  spaDate: string;
  adults: number;
  children: number;
  spaAdults: number;
  tableAdults: number;
  tableChildren: number;
}>;

export function buildSearchHandoffQuery(
  category: string,
  { from, to, adults, children }: { from: string | null; to: string | null; adults: number; children: number }
): SearchHandoffQuery {
  const isSpa = SPA_CATEGORIES.has(category);
  const isTables = category === 'tables';
  const singleDate = isSingleDateCategory(category);

  const dateFields: SearchHandoffQuery = {};
  if (from) {
    dateFields.fromDate = from;
    if (!singleDate && to) {
      dateFields.toDate = to;
    }
    if (isSpa) {
      dateFields.spaDate = from;
    }
  }

  if (isSpa) {
    return { ...dateFields, spaAdults: adults };
  }
  if (isTables) {
    return { ...dateFields, tableAdults: adults, tableChildren: 0 };
  }
  return { ...dateFields, adults, children };
}
